import VirtualList from './src/main';

/* istanbul ignore next */
VirtualList.install = function(Vue) {
  Vue.component(VirtualList.name, VirtualList);
};

export default VirtualList;
